import React from 'react';

import styles from './Footer.module.scss';

function Footer() {
  return (
    <div className={styles.container_footer}>
      <p style={{color: '#FFFFFF'}}>This site is protected by reCAPTCHA and the Google
        <a href='https://policies.google.com/privacy'>Privacy Policy</a> and
        <a href='https://policies.google.com/terms'>Terms of Service</a> apply.
      </p>
    </div>
  );
}

export default Footer;
